<app-navbar title="Obsługa rezerwacji">
	<div class="button-row">
		<button class="btn btn-danger" routerLink="../../reservationList">
			<i class="fas fa-chevron-left"></i>Powrót do listy
		</button>
	</div>
</app-navbar>
<div class="py-5 px-3">
	<div class="header row" *ngIf="reservation">
		<div class="col">
			<h2>
				<a [href]="offerUrl" target="_blank" class="text-black text-decoration-none hover-lighten"
					>{{ reservation.id }} {{ isTourNumber }} {{ product }}</a
				>
			</h2>
			<h4 *ngIf="reservation.time.lower && reservation.time.upper">
				{{ reservation.time.lower | date: 'dd.MM' }} -
				{{ reservation.time.upper | date: 'dd.MM.yyyy' }}
				{{ reservation.days }}d/{{ reservation.nightsStay }}n
				<i
					class="fa fa-info-circle fs-6"
					*ngIf="reservation.nightsStay === 999"
					matTooltip="Dana rezerwacja posiada więcej niż jedną ofertę."
				></i>
			</h4>
		</div>
		<div class="col">
			<h4>
				Wartość rezerwacji:
				{{ +reservation.totalPrice | price }}
				{{ reservation.currency.code }}
				| Prowizja: {{ reservation.commissionValue | price }}
				{{ reservation.currency.code }}

				@if (isAdmin()) {
					<i
						class="fa fa-pencil-alt cursor-pointer changeCommissionValueButton"
						(click)="showCommissionEditDialog()"
					></i>
				}
				<br />
				Wartość rezerwacji bez prowizji:
				{{ +reservation.totalPrice - reservation.commissionValue | price }}
				{{ reservation.currency.code }}
			</h4>
			<h5 class="d-flex">
				Kanał sprzedaży:
				<div class="cursor-pointer text-decoration-underline" [matMenuTriggerFor]="">
					{{ reservation.channel }}
				</div>
				@if (false) {
					<mat-menu #menu="matMenu">
						<ng-container *ngFor="let channel of channels | async">
							<button (click)="changeChannel(channel.id)" mat-menu-item>
								{{ channel.name }}
							</button>
						</ng-container>
					</mat-menu>
				}
			</h5>
			<h5>Organizator: {{ reservation.organization.shortName }}</h5>

			@if (activeReservationInsurer()) {
				<h5>Ubezpieczyciel: {{ activeReservationInsurer()?.name }}</h5>
			}

			<div>
				<mat-form-field>
					<mat-label>Kod vouchera</mat-label>
					<input matInput type="text" name="voucher" [(ngModel)]="voucherCode" />
				</mat-form-field>
				@if (voucherValue) {
					<button mat-raised-button color="warn" (click)="deleteVoucher()" class="submit-btn">Usuń</button>
				} @else {
					<button mat-raised-button color="primary" (click)="submitVoucher()" class="submit-btn">
						Dodaj
					</button>
				}
			</div>

			@if (voucherValue) {
				<p>Wartość vouchera: -{{ voucherValue | price }}zł</p>
			}
		</div>
	</div>
	<mat-tab-group (selectedTabChange)="onSelectedTabChange($event)" mat-stretch-tabs="false" mat-align-tabs="start">
		<mat-tab class="overflow-hidden" label="Podsumowanie">
			<app-reservation-summary></app-reservation-summary>
		</mat-tab>
		<mat-tab label="Dokumenty">
			<app-reservation-documents></app-reservation-documents>
		</mat-tab>
		<mat-tab label="Zadania i notatki">
			<app-reservation-task-and-notes [resourceID]="reservationId"></app-reservation-task-and-notes>
		</mat-tab>
		<mat-tab label="Historia korespondencji">
			<app-reservation-message-list></app-reservation-message-list>
			<app-reservation-sms-list [reservationId]="reservationId"></app-reservation-sms-list>
		</mat-tab>
		<mat-tab [disabled]="comfortPackageDisabled" [label]="COMFORT_PACKAGE_LABEL">
			<button
				mat-flat-button
				matTooltip="Musisz wybrać miejsca dla wszystkich uczestników dla wszystkich autobusów"
				[matTooltipDisabled]="(saveSeatsBtnDisabled$ | async) === false"
				[ngClass]="{ 'disabled-btn': saveSeatsBtnDisabled$ | async }"
				class="btn btn-primary save-seats-btn"
				(click)="saveSeats()"
			>
				Zapisz siedzenia
			</button>
			@if (offer.product.productKind.id === ProductKind.VACATION) {
				<app-comfort-package-departure (confirmSeats)="confirmSeats($event)"></app-comfort-package-departure>
				<app-comfort-package-return (confirmSeats)="confirmSeats($event)"></app-comfort-package-return>
			} @else {
				<app-comfort-package-one-transport
					(confirmSeats)="confirmSeats($event)"
				></app-comfort-package-one-transport>
			}
		</mat-tab>
	</mat-tab-group>
</div>
